<template>
    <gz-auth-view-template :bc="false">
        <GZ-PageTitle title="Проверки" slot="title"/>        
        <GZ-StaticNotification slot="notification"/>

        <section slot="content">
        </section>        

        <GZ-Pagination slot="pagination"/>

    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminReportsView'
}
</script>